(function fragmentumBadgeSwap() {
  'use strict';

  function swap() {
    var bvEls = document.querySelectorAll('.fh-bv');
    if (!bvEls.length) return;

    bvEls.forEach(function(bvEl) {
      if (bvEl.classList.contains('fragmentum-mp')) return;

      var parentLabel = bvEl.closest('label');
      if (!parentLabel) return;

      var inputId = parentLabel.getAttribute('for');
      if (!inputId) return;
      var input = document.getElementById(inputId);
      if (!input) return;

      var val = (input.value || '').toLowerCase();
      if (!val.includes('5ml')) return;

      var allInputs = document.querySelectorAll('input[type="radio"][name="' + input.name + '"]');
      var label8ml = null;

      allInputs.forEach(function(inp) {
        if ((inp.value || '').toLowerCase().includes('8ml')) {
          var lbl = document.querySelector('label[for="' + inp.id + '"]');
          if (lbl) label8ml = lbl;
        }
      });

      if (!label8ml) return;

      parentLabel.removeChild(bvEl);
      label8ml.appendChild(bvEl);

      if (!parentLabel.querySelector('.fragmentum-mp')) {
        var mpEl = document.createElement('span');
        mpEl.className = 'fh-bv fragmentum-mp';
        mpEl.textContent = 'Most popular';
        parentLabel.appendChild(mpEl);
      }
    });
  }

  var done = false;

  function runOnce() {
    if (done) return;
    if (!document.querySelector('.fh-bv')) return;
    done = true;
    swap();
  }

  var obs = new MutationObserver(function() { runOnce(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  setTimeout(runOnce, 300);
  setTimeout(runOnce, 800);
  setTimeout(runOnce, 2000);
})();
